import { IPaginationDTO, IPaginationResponse } from './pagination.model';

export enum GoogleMerchantSyncEndpoint {
  ROOT = '/google-merchant/sync',
  DELTA = '/delta',
  PRODUCT = '/product',
  RUNS = '/runs',
}

export const getGoogleMerchantSyncEndpoints = ({ channelSlug }: { channelSlug: string }) => ({
  GET_MERCHANT_SYNC_RUNS: `${GoogleMerchantSyncEndpoint.ROOT}/${channelSlug}${GoogleMerchantSyncEndpoint.RUNS}`,
  SYNC_FULL: `${GoogleMerchantSyncEndpoint.ROOT}/${channelSlug}`,
  SYNC_DELTA: `${GoogleMerchantSyncEndpoint.ROOT}/${channelSlug}${GoogleMerchantSyncEndpoint.DELTA}`,
  SYNC_PRODUCT: `${GoogleMerchantSyncEndpoint.ROOT}/${channelSlug}${GoogleMerchantSyncEndpoint.PRODUCT}`,
});

export enum GoogleMerchantSyncRunMode {
  FULL = 'FULL',
  DELTA = 'DELTA',
  PRODUCT = 'PRODUCT',
}

export enum GoogleMerchantSyncRunStatus {
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
}

export interface IGoogleMerchantSyncRun {
  id: string;
  channelId: number;
  mode: GoogleMerchantSyncRunMode;
  status: GoogleMerchantSyncRunStatus;
  requestedByUserId?: string | null;
  startedAt: string;
  finishedAt?: string | null;
  processedCount: number;
  successCount: number;
  failedCount: number;
  skippedCount: number;
  deleteAttemptCount: number;
  deleteSuccessCount: number;
  deleteFailedCount: number;
  errorSummary?: Record<string, unknown> | null;
  checkpoint?: Record<string, unknown> | null;
  heartbeatAt?: string | null;
  idempotencyKey?: string | null;
  failureCode?: string | null;
}

// ============== DTO ==============

export interface IGoogleMerchantFullSyncEnqueueDTO {
  idempotencyKey: string | null;
  channelSlug: string;
}

export interface IGoogleMerchantDeltaSyncEnqueueDTO {
  idempotencyKey: string | null;
  channelSlug: string;
  since: string | null;
}

export interface IGoogleMerchantProductSyncEnqueueDTO {
  idempotencyKey: string | null;
  channelSlug: string;
  sku: string;
}

export interface IGetGoogleMerchantSyncRunsDTO extends IPaginationDTO {
  channelSlug: string;
}

// ============== Response ==============

export interface IGoogleMerchantSyncEnqueueResponse {
  jobId: string;
  mode: GoogleMerchantSyncRunMode;
  channelSlug: string;
  alreadyQueued: boolean;
}

export interface IGetGoogleMerchantSyncRunsResponse extends IPaginationResponse {
  items: IGoogleMerchantSyncRun[];
}
